import { FlightRequest, SearchOnlyAviaPackagesRequest, SearchOnlyAviaPackagesResponse } from '@appTypes/api.types';
import { AirportTreeItem } from '@appTypes/redefined-types';
import { DataLoadStatusModel, RequestStateModel, StateFormModel } from '@core/store/store.models';
import { AviaFilterStopsType, AviaSearchFormExtraParams, TicketTypesEnum } from '@pages/avia-page/avia-page.types';

export class AviaPageDataModel {
  airports = new RequestStateModel<AirportTreeItem[]>();
  airports_flat: AirportTreeItem[] = [];
}
export class AviaFilterFormModel {
  airlines: string[] = [];
  stopsType: AviaFilterStopsType | null = null;
  /** website-web#11: the longest a direction may take, door to door (hours); null = any */
  maxJourneyHours: number | null = null;
}
export class AviaStateModel {
  searchForm = new StateFormModel<SearchOnlyAviaPackagesRequest & AviaSearchFormExtraParams>();
  searchLoadStatus = new DataLoadStatusModel();
  searchResults = new RequestStateModel<SearchOnlyAviaPackagesResponse>();
  /** The classes of the last search (avia-class-multi-select R-CM3): the results' texts follow these, not the live Класс dropdown. */
  searchedTicketTypes: TicketTypesEnum[] = [];
  /** Q-9 (airport-picker R-3, docs#447 point 1): the places of the last search - the rows mark another airport of a picked airport's city. */
  searchedFlightRequests: FlightRequest[] = [];
  filterForm = new StateFormModel(new AviaFilterFormModel());
  pageData = new AviaPageDataModel();
}
